import React from "react";
import ReactDOM from "react-dom";
import "@cdk-uip/icons";
import "@cdk-uip/react/cdk.css";
import "typeface-roboto";

import { ValidateSession } from "./services/auth/AuthService";

import OnePayAdmin from "./components/onePay/OnePayAdmin";

import "./index.css";

(async () => {
  await ValidateSession();

  ReactDOM.render(
    <dev>
      <OnePayAdmin />
    </dev>,
    document.getElementById("root")
  );
})();
